import React from 'react';

import { useFormContext } from 'react-hook-form';

import { NameSection, TagsSection } from '../../../shared';
import * as types from '../../../types';

type Props = Pick<types.CommonFormValues, 'type'>;

function CommonForm({ type }: Props) {
  const methods = useFormContext<types.CommonFormValues>();
  const { control } = methods;

  const nameInputPlaceholder = (() => {
    if (type === types.EPageType.ABOUT_SAFARI || type === types.EPageType.PRE_TRAVEL_INFO) return 'Page Name*';
  })();

  return (
    <div>
      <NameSection nameInputPlaceholder={nameInputPlaceholder} control={control}>
        I. Page Details
      </NameSection>

      <TagsSection methods={methods} />
    </div>
  );
}

export { CommonForm };
